<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h2 id="downloads">Downloads</h2>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>
          The data and results displayed in this report can be downloaded for use in further GIS analysis. Raster files are in GeoTIFF format, and 
          vector files are in GeoJSON format, both of which can be imported in a GIS programme like QGIS.
        </p>
        <ul class="bullets">
          <li><a v-bind:href="makeUrl('hansen_forest_loss_hotspots/hotspots_100_geom.geojson')">Tree Cover Loss Hotspots (GeoJSON)</a></li>
          <li><a v-bind:href="makeUrl('jrc_tmf_hotspots/deforestation_hotspots_100_geom.geojson')">JRC TMF Degradation Hotspots (GeoJSON)</a></li>
          <li><a v-bind:href="makeUrl('jrc_tmf_hotspots/degradation_hotspots_100_geom.geojson')">JRC TMF Deforestation Hotspots (GeoJSON)</a></li>
          <li><a v-bind:href="makeUrl('copernicus_dem/copernicus_DEM.tif')">Copernicus DEM (GeoTIFF)</a></li>
          <li><a v-bind:href="makeUrl('esa_worldcover/worldcover.tif')">ESA WorldCover (GeoTIFF)</a></li>
          <li><a v-bind:href="makeUrl('geofolio_ldr_aoi/aois.geojson')">Areas of Interest (GeoJSON)</a></li>

          

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import _ from 'lodash'; 

  export default {
    name: 'downloads',
    props: ['location', 'factsheet', 'loaded'],
    components: {    },
    data() {
        return {
        }
    },
    computed: {
        factsheetApiUrl: function() {
            return process.env.VUE_APP_API+"/api/factsheet/"+this.factsheet.identifier+'/';
        },
    },
    created() {

    },
    mounted() {
    },
    watch: {
    },
    methods: {
      makeUrl(path) {
        return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.identifier+'/data/'+path

      }
    }
  }
</script>

<style scoped>
ul {
  -webkit-column-count:1;
  -moz-column-count:1;
  column-count:1;
}
li {
  color:#888;
  font-size:0.75em;
  line-height:1.3em;
  padding-bottom:0px !important;
}
li a {
  color:#888;
  text-decoration:underline;
  text-decoration-color:#aaa;
}
</style>